module.exports = "<p>\n  reportplus works!\n</p>\n"